import React from 'react';
import './KeyInsightsList.css';

export default function KeyInsightsList({ insights, loading }) {
  return (
    <div className="key-insights-card">
      <h3>Key Insights</h3>
      {loading ? (
        <div className="spinner-container">
          <div className="spinner" />
        </div>
      ) : (
        <div className="insights-list">
          {insights && insights.length > 0 ? (
            insights.map((item, idx) => (
              <div className="insight-item" key={idx}>
                <div className="insight-header">
                  <span className="insight-title">{item.title}</span>
                  <span className="insight-confidence">{item.confidence}</span>
                </div>
                <div className="insight-description">{item.description}</div>
              </div>
            ))
          ) : (
            <div className="no-insights">No insights available.</div>
          )}
        </div>
      )}
    </div>
  );
}
